package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_03_28_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-03-28")
@Composable
public fun Log_2026_03_28(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Saturday Night Cleaver",
        ogTitle = "Saturday Night Cleaver",
        date = LocalDate(2_026, 3, 28),
        aiHint = "Image, title, and description are a joke.",
        ogDescription = "He is Frank Ettin, king of the discos (and kitchen knives). Every guy wants to dance like him. Every girl wants to be with him.",
        ogImage = "images/saturdayNightCleaver.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of a two-headed giant (Ettin) wearing furs and a skull-decorated belt, holding a large blue cleaver. This is a meme reference to Saturday Night Fever. The mushroom cloud on the left is a reference to all the fireballs the heroes have been throwing at the giants and Ettins.",
    ) {
        SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22", cardImageSrc = "images/saturdayNightCleaver.webp", width = 1_200, height = 630)
        Log_2026_03_28_Day_1()
        SessionMediaItem(
            image = "images/dancingEttin.webp",
            linkImage = "images/dancingEttin.webp",
            description = "A hand-drawn illustration of a two-headed giant (Ettin) wearing furs and a skull-decorated belt, holding a large blue cleaver. This is a meme reference to Saturday Night Fever. The mushroom cloud on the left is a reference to all the fireballs the heroes have been throwing at the giants and Ettins.",
            width = 1_424,
            height = 1_773,
        )
        SessionMediaItem(
            image = "images/mushroomCloud.webp",
            linkImage = "images/mushroomCloud.webp",
            description = "A hand-drawn illustration of a large mushroom cloud in shades of yellow, orange, and red caused by the D&D 5e spell \"Fireball.\"",
            width = 1_315,
            height = 1_068,
        )
    }
}
